import React from 'react'

class Cafe extends React.Component {
  render() {
    return (
      <div className="mp__cafe">
        <div className="wd">
          <div className="mp__sec__content">
            <h2>Не залишимо тебе голодним…</h2>
            <div className="mp__sec__content__texts">
                <p>Кінокафе Gastroll' ─ це добротні страви європейської кухні у товаристві найкращих людей з України, Європи, США чи інших країн, глядачі яких встигли придбати квитки на сеанси у «Жовтні».  </p>
                <p>Стильний лофт, де креативний клас обмінюється думками із буржуями, неофітами і зірками української кіноіндустрії.</p>
            </div>
            <a href="https://www.facebook.com/Gastroll" className="mp__sec__content__button">Сторінка в FB</a>
          </div>
          <img src="/img/il_1.png" alt="Кінокафе Gastroll'" className="mp__cafe__ill" />
        </div>
      </div>
    )
  }
}

export default Cafe


// WEBPACK FOOTER //
// ./src/components/pages/HomePage/cafe.jsx